module.exports = __webpack_public_path__ + "static/media/boltIcon-active.9ef1a82d.svg";